import axios from '@/libs/axios'

export default {
  getEmptySpots(serviceId, params) {
    return axios.get(`/public/booking/${serviceId}/spots`, { params })
  },
  book(payload) {
    return axios.post('/public/booking/book', payload)
  },
  estimatePrice(payload) {
    return axios.post('/public/booking/price', payload)
  },
}
